import { sentimentToColor } from './sentimentColors';
import styles from './SentimentOverlay.module.css';

export interface SentimentOverlayProps {
  intervalLength: number;
  intervals: number[];
  videoDuration: number;
}

function getSafeSegmentValue(value: number | undefined) {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function SentimentOverlay({
  intervalLength,
  intervals,
  videoDuration,
}: SentimentOverlayProps) {
  if (videoDuration <= 0 || intervalLength <= 0) {
    return null;
  }

  const segmentCount = Math.ceil(videoDuration / intervalLength);

  return (
    <div
      aria-hidden="true"
      className={styles.overlay}
      data-testid="sentiment-overlay"
      style={{ pointerEvents: 'none' }}
    >
      {Array.from({ length: segmentCount }, (_unused, index) => {
        const startSeconds = index * intervalLength;
        const endSeconds = Math.min(startSeconds + intervalLength, videoDuration);
        const left = (startSeconds / videoDuration) * 100;
        const width = ((endSeconds - startSeconds) / videoDuration) * 100;
        const value = getSafeSegmentValue(intervals[index]);

        return (
          <span
            className={styles.segment}
            data-testid="sentiment-segment"
            key={index}
            style={{
              backgroundColor: sentimentToColor(value),
              left: `${left}%`,
              width: `${width}%`,
            }}
          />
        );
      })}
    </div>
  );
}
